import React from 'react';
import { Button } from 'rmwc/Button';
import gtagEvent from '../../utilities/analytics/gtag-event';

import './landing-pages.css';
import '@material/button/dist/mdc.button.min.css';

const heroUri = 'https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2Flanding-page-primary-stephanie-lorraine.jpg?alt=media&token=864f89ea-676d-4b17-b61d-259616064f8b';

export default props => {
  return (
    <article id="calligraphy-workshops" className="static-landing-page" role="main">
      <section className="centered">
        <div className="row">
          <div className="hide-small">
            <img className="hero" src={heroUri} alt="In-Person Calligraphy Workshops" />
          </div>
          <div className="flex">
            <h1 className="headline-text">Calligraphy Workshops</h1>
            <p className="primary-text">We teach live workshops</p>
            <p className="secondary-text">
              <strong>Interested in scheduling a custom workshop?</strong> <br /> Email Melissa at{' '}
              <a href="mailto:melissa@calligraphy.org?subject=Calligraphy.org Questions&body=Hey Melissa,">
                melissa@calligraphy.org
              </a>
              . She's taught all over the US.
            </p>
            <a href="https://melissapher.eventbrite.com/" target="_blank">
              <Button
                className="cta-button"
                raised
                onClick={() =>
                  gtagEvent('cta-click', { page: 'calligraphy-workshops', position: 'primary' })
                }
              >
                Visit Melissa's Eventbrite
              </Button>
            </a>
          </div>
        </div>
      </section>
    </article>
  );
};
